
function Contact() {
  return (
    <div>
        <div class="row">
            <div class="col-lg-12">
                <h1 class="page-header">اتصل بنا</h1>
                <ol class="breadcrumb">
                    <li><a href="/">الرئيسية &gt;&gt; </a>
                    </li>
                    <li class="active">عنا</li>
                </ol>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-8">
                <h3>ارسل لنا رسالة</h3>
                <form name="sentMessage" id="contactForm" novalidate>
                    <div class="control-group form-group">
                        <div class="controls">
                            <label>الاسم الكامل:</label>
                            <input type="text" class="form-control" id="name" required data-validation-required-message="Please enter your name." />
                            <p class="help-block"></p>
                        </div>
                    </div>
                    <div class="control-group form-group">
                        <div class="controls">
                            <label>البريد الالكتروني:</label>
                            <input type="email" class="form-control" id="email" required data-validation-required-message="Please enter your email address." />
                        </div>
                    </div>
                    <div class="control-group form-group">
                        <div class="controls">
                            <label>الرسالة:</label>
                            <textarea rows="10" cols="100" class="form-control" id="message" required data-validation-required-message="Please enter your message" maxlength="999" style={{"resize" : "none"}}></textarea>
                        </div>
                    </div>
                    <div id="success"></div>
                    <button type="submit" class="btn btn-primary">ارسال</button>
                </form>
            </div>
            <div class="col-md-4">
            </div>
        </div>

        <hr />
        
        <footer>
            <div class="row">
                <div class="col-lg-3">
					<div style={{"float" : "left", "padding-right" : "10px"}}>
                        <img src="img/img.png" class="img-thumbnail img-circle elevation-2" style={{"width" : "120px", "height" : "120px"}} />
                    </div>
					<div style={{"float" : "left", "text-align" : "left"}}>
						<p>Copyright &copy; <br /> 2020 - 2024</p>
					</div>
                </div>
                <div class="col-lg-4">
                    <div style={{"float" : "left", "padding-right" : "10px"}}>
                        <img src="uploads/img01.jpg" class="img-thumbnail img-circle elevation-2" style={{"width" : "120px", "height" : "120px"}} />
                    </div>
					<div style={{"float" : "left", "text-align" : "left"}}>
                        Prof. ADALA Laadjal <br /> Founder and Director of <br /> the Green journals Platform
                    </div>
                </div>
                <div class="col-lg-4">
					<div style={{"float" : "left", "padding-right" : "10px"}}>
						<a target="_blank" href="https://www.facebook.com/abgrcs/">
                            <img src="uploads/img02.jpg" class="img-thumbnail img-circle elevation-2" style={{"width" : "120px", "height" : "120px"}} />
                        </a>
					</div>
					<div style={{"float" : "left", "text-align" : "left"}}>
						<a target="_blank" href="https://www.facebook.com/abgrcs/">GHRICI Abdellah</a>
						<p>Technical Supervisor</p>
					</div>
                </div>
            </div>
        </footer>
    </div>
  );
}

export default Contact;
